import { Card } from "@mui/material";
import { DomainForm } from "./DomainForm";

const FormCard = props => {

	return (
		<div className="pt-10">
			<div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
				<Card className="p-3 md:p-10 md:pt-8" sx={{
					bgcolor: "#f3f4f6"
				}}>
					<p className="text-2xl text-[#5e6673] leading-8 font-bold tracking-tight mb-2">
						Test Your Domain Now
					</p>
					<div className="domain-form">
						<div className="relative text-gray-700">
							<DomainForm />
						</div>
					</div>
				</Card>
			</div>
		</div>
	);
};

export default FormCard;